import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import { routes } from 'flow/types/routes';
import CallHistoryV2 from './call-history-v2/CallHistoryV2';
import ExtensionListTab_TW from './nav/ExtensionListTab';
import PbxNavigation from './nav/PbxNavigation';
import Sessions from './nav/Sessions';
import SettingsNavigation from './nav/SettingsNavigation';
import TicketsListsSection_TW from './nav/TicketsListsSection';
import { isExtensionKey } from 'flow/utils';
import { CENTRAL_SWITCH_OVERVIEW_KEY } from './nav/contact-list/contact-list-rows';

// The contact list's open item. The Overview opens at the list's own route
// too, with no key in it.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var openExtensionListItem = function openExtensionListItem(entityKey, setting) {
  if (isExtensionKey(entityKey)) {
    return entityKey;
  }
  if (entityKey === undefined || entityKey === 'overview') {
    return CENTRAL_SWITCH_OVERVIEW_KEY;
  }
  return setting;
};
var Navigator = function Navigator(props) {
  var entityKey = props.entityKey,
    setting = props.setting;
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: routes['extensions'],
      render: function render(props) {
        return /*#__PURE__*/_jsx(ExtensionListTab_TW, _objectSpread(_objectSpread({}, props), {}, {
          selected: openExtensionListItem(entityKey, setting)
        }));
      }
    }), /*#__PURE__*/_jsx(Route, {
      path: [routes['messages.id'], routes['messages'], routes['videoLink']],
      render: function render(props) {
        return /*#__PURE__*/_jsx(Sessions, _objectSpread({}, props));
      }
    }), /*#__PURE__*/_jsx(Route, {
      path: [routes['pbx.navigation'], routes['pbx']],
      render: function render() {
        return /*#__PURE__*/_jsx(PbxNavigation, {});
      }
    }), /*#__PURE__*/_jsx(Route, {
      path: [routes['calls.callRecordKey'], routes['calls']],
      render: function render() {
        return /*#__PURE__*/_jsx(CallHistoryV2, {});
      }
    }), /*#__PURE__*/_jsx(Route, {
      path: routes['tickets'],
      render: function render(props) {
        return /*#__PURE__*/_jsx(TicketsListsSection_TW, _objectSpread(_objectSpread({}, props), {}, {
          selected: setting
        }));
      }
    }), /*#__PURE__*/_jsx(Route, {
      path: [routes['settings'], '/settings'],
      render: function render(props) {
        return /*#__PURE__*/_jsx(SettingsNavigation, _objectSpread(_objectSpread({}, props), {}, {
          selected: setting
        }));
      }
    })]
  });
};
Navigator.propTypes = {
  defaultTab: PropTypes.oneOf(['extensions', 'messages', 'pbx', 'calls', 'settings', 'start', 'omni', 'tickets']),
  entityKey: PropTypes.string,
  setting: PropTypes.string
};
export default /*#__PURE__*/React.memo(Navigator);